/**
 * honestly, this is probably not a good idea, but we have
 * a very limited use case for now
 * @param {string} query
 */
export const parseQueryString: (query: string) => {} = query => {
  const [str] = query.split('?').reverse()

  return str
    .split('&')
    .map(pair => pair.split('='))
    .reduce(
      (acc, [key, val]) => ({
        ...acc,
        [decodeURIComponent(key)]: decodeURIComponent(val)
      }),
      {}
    )
}

const computeScore = (text: string, wordRegexes: any) => {
  return wordRegexes
    .map((regex: RegExp) => countMatches(text, regex))
    .map((count: number) => Math.sqrt(count))
    .reduce((sum: number, count: number) => sum + count, 0)
}

const countMatches = (text: string, regex: RegExp) => {
  const matches = text.match(regex)

  return matches ? matches.length : 0
}

export const getHighestRankedText = (texts: any, wordRegexes: any) => {
  const { text = null } = texts
    .map((text: string) => ({
      text,
      score: computeScore(text, wordRegexes)
    }))
    .reduce((best: any, curr: any) => (curr.score > best.score ? curr : best), {
      score: -1
    })

  return text
}
